import { keys } from 'lodash';

import { errorsStore } from 'stores';

import { REGISTRATION_FORM } from '../../constants';

import { giftcardErrors } from '../../selectors/giftcards/giftcardErrors';

/**
 * @description
 * Collect all invalid coupons in the form
 * and add those errors to the errorsStore(connect to the form)
 */
function addGiftcardErrors() {
  const errors = giftcardErrors.get() as {};
  errorsStore.clean(REGISTRATION_FORM, ...keys(errors));
  errorsStore.add(REGISTRATION_FORM, errors);
}

export { addGiftcardErrors };
